const Examples = {
  Common: {
    NotNull: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .NotNull()
    .Build();

var result = validator.Validate(null);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .NotNull(e => e.FirstName)
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.NotNull())
    .Build();

var result = validator.Validate(new Employee { LastName = "Simpson" });`,
    },
    Null: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Null()
    .Build();

var result = validator.Validate(null);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Null(e => e.FirstName)
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Null())
    .Build();

var result = validator.Validate(new Employee { LastName = "Simpson" });`,
    },
    Equal: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Equal("Smithers")
    .Build();

var result = validator.Validate("Smithers");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Equal(e => e.FirstName, "Homer")
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.LastName, v => v.Equal("Smithers"))
    .Build();
    
var result = validator.Validate(new Employee { LastName = "Simpson" });`,
    },
    NotEqual: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .NotEqual(17)
    .Build();

var result = validator.Validate(18);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .NotEqual(e => e.Age, 17)
    .Build();

var result = validator.Validate(new Employee { Age = 18 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.NotEqual(17))
    .Build();

var result = validator.Validate(new Employee { Age = 18 });`,
    },
  },
  Comparison: {
    GreaterThan: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .GreaterThan(18)
    .Build();
  
var result = validator.Validate(16);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .GreaterThan(e => e.Age, 18)
    .Build();

var result = validator.Validate(new Employee { Age = 20 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.GreaterThan(18))
    .Build();

var result = validator.Validate(new Employee { Age = 17 });`,
    },
    GreaterThanOrEqual: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .GreaterThanOrEqual(18)
    .Build();
  
var result = validator.Validate(16);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .GreaterThanOrEqual(e => e.Age, 18)
    .Build();

var result = validator.Validate(new Employee { Age = 20 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.GreaterThanOrEqual(18))
    .Build();

var result = validator.Validate(new Employee { Age = 17 });`,
    },
    LessThan: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .LessThan(18)
    .Build();
  
var result = validator.Validate(16);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .LessThan(e => e.Age, 18)
    .Build();

var result = validator.Validate(new Employee { Age = 20 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.LessThan(18))
    .Build();

var result = validator.Validate(new Employee { Age = 17 });`,
    },
    LessThanOrEqual: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .LessThanOrEqual(18)
    .Build();
  
var result = validator.Validate(16);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .LessThanOrEqual(e => e.Age, 18)
    .Build();

var result = validator.Validate(new Employee { Age = 20 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.LessThanOrEqual(18))
    .Build();

var result = validator.Validate(new Employee { Age = 17 });`,
    },
    Range: {
      Example1: `var validator = new ValidatorBuilder<int>()
    .Range(18, 30)
    .Build();
  
var result = validator.Validate(24);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Range(e => e.Age, 18, 30)
    .Build();

var result = validator.Validate(new Employee { Age = 20 });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Age, v => v.Range(18, 30))
    .Build();

var result = validator.Validate(new Employee { Age = 17 });`,
    },
    Compare: {
      Example1: `var validator = new ValidatorBuilder<LoginModel>()
    .Compare(m => m.Password, m => m.PasswordConfirm)
    .Build();

var result = validator.Validate(new LoginModel 
    { 
        Password = "StrongP@ssw0rd",
        PasswordConfirm = "StrongPassw0rd"
    });`,
    },
  },
  String: {
    NotEmpty: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .NotEmpty()
    .Build();

var result = validator.Validate(null);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .NotEmpty(e => e.FirstName)
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.NotEmpty())
    .Build();

var result = validator.Validate(new Employee { LastName = "Simpson" });`,
    },
    Empty: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Empty()
    .Build();

var result = validator.Validate("");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Empty(e => e.FirstName)
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Empty())
    .Build();

var result = validator.Validate(new Employee { LastName = "Simpson" });`,
    },
    Regex: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Regex("^[0-9]*$")
    .Build();

var result = validator.Validate("12345");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Regex(e => e.FirstName, "^[0-9]*$")
    .Build();

var result = validator.Validate(new Employee { FirstName = "Six" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Regex("^[0-9]*$"))
    .Build();

var result = validator.Validate(new Employee { FirstName = "7 of 9" });`,

      Example4: `var validator = new ValidatorBuilder<string>()
    .Regex("^[a-z]*$", RegexOptions.IgnoreCase)
    .Build();

var result = validator.Validate("ABC");`,
    },
    StartsWith: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .StartsWith("fun")
    .Build();

var result = validator.Validate("function");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .StartsWith(e => e.FirstName, "Jo")
    .Build();

var result = validator.Validate(new Employee { FirstName = "Homer" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.StartsWith("Pet"))
    .Build();

var result = validator.Validate(new Employee { FirstName = "Peter" });`,
    },
    EndsWith: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .EndsWith("on")
    .Build();

var result = validator.Validate("function");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .EndsWith(e => e.FirstName, "son")
    .Build();

var result = validator.Validate(new Employee { FirstName = "Jason" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.EndsWith("art"))
    .Build();

var result = validator.Validate(new Employee { FirstName = "Lisa" });`,
    },
    Contains: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Contains("tio")
    .Build();

var result = validator.Validate("function");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Contains(e => e.FirstName, "aso")
    .Build();

var result = validator.Validate(new Employee { FirstName = "Jason" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Contains("holo"))
    .Build();

var result = validator.Validate(new Employee { FirstName = "Bartholomew" });`,
    },
    Length: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Length(3, 8)
    .Build();

var result = validator.Validate("function");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Length(e => e.FirstName, 1, 15)
    .Build();

var result = validator.Validate(new Employee { FirstName = "Jason" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Length(1, 10))
    .Build();

var result = validator.Validate(new Employee { FirstName = "Bartholomew" });`,
    },
    MinLength: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .MinLength(3)
    .Build();

var result = validator.Validate("stop");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .MinLength(e => e.Role, 5)
    .Build();

var result = validator.Validate(new Employee { Role = "Admin" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.MinLength(4))
    .Build();

var result = validator.Validate(new Employee { FirstName = "Bart" });`,
    },
    MaxLength: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .MaxLength(6)
    .Build();

var result = validator.Validate("validate");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .MaxLength(e => e.Lastname, 12)
    .Build();

var result = validator.Validate(new Employee { LastName = "Smithers" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.MaxLength(4))
    .Build();

var result = validator.Validate(new Employee { FirstName = "El Barto" });`,
    },
    Required: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Required()
    .Build();

var result = validator.Validate(null);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Required(e => e.FirstName)
    .Build();

var result = validator.Validate(new Employee { FirstName = "" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.FirstName, v => v.Required())
    .Build();

var result = validator.Validate(new Employee { FirstName = "   " });`,
    },
    Email: {
      Example1: `var validator = new ValidatorBuilder<string>()
    .Email()
    .Build();

var result = validator.Validate("bart@example.com");`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Email(e => e.Email)
    .Build();

var result = validator.Validate(new Employee { Email = "invalid[at]email.com" });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Email, v => v.Email())
    .Build();

var result = validator.Validate(new Employee { Email = "homer@gmail.com" });`,
    },
  },
  Boolean: {
    True: {
      Example1: `var validator = new ValidatorBuilder<bool>()
    .True()
    .Build();

var result = validator.Validate(1 == 1);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .True(e => e.Active)
    .Build();

var result = validator.Validate(new Employee { Active = false });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Active, v => v.True())
    .Build();

var result = validator.Validate(new Employee { Active = true });`,
    },
    False: {
      Example1: `var validator = new ValidatorBuilder<bool>()
    .False()
    .Build();

var result = validator.Validate(1 == 1);`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .False(e => e.Active)
    .Build();

var result = validator.Validate(new Employee { Active = false });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Active, v => v.False())
    .Build();

var result = validator.Validate(new Employee { Active = true });`,
    },
  },
  Collection: {
    Count: {
      Example1: `var validator = new ValidatorBuilder<IEnumerable<string>>()
    .Count(2)
    .Build();

var result = validator.Validate(new[] { "One", "Two" });`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Count(e => e.Skills, 2)
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Cromulent" } });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Skills, v => v.Count(1))
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Vandalism" } });`,
    },
    MinCount: {
      Example1: `var validator = new ValidatorBuilder<IEnumerable<string>>()
    .MinCount(2)
    .Build();

var result = validator.Validate(new[] { "One" });`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .MinCount(e => e.Skills, 2)
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Cromulent" } });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Skills, v => v.MinCount(1))
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Vandalism" } });`,
    },
    MaxCount: {
      Example1: `var validator = new ValidatorBuilder<IEnumerable<string>>()
    .MaxCount(2)
    .Build();

var result = validator.Validate(new[] { "One" });`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .MaxCount(e => e.Skills, 2)
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Cromulent" } });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Skills, v => v.MaxCount(1))
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Vandalism" } });`,
    },
    Contains: {
      Example1: `var validator = new ValidatorBuilder<IEnumerable<string>>()
    .Contains("Two")
    .Build();

var result = validator.Validate(new[] { "One", "Two", "Three" });`,

      Example2: `var validator = new ValidatorBuilder<Employee>()
    .Contains(e => e.Skills, "Cromulent")
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Cromulent" } });`,

      Example3: `var validator = new ValidatorBuilder<Employee>()
    .For(e => e.Skills, v => v.Contains("Chill"))
    .Build();

var result = validator.Validate(new Employee { Skills = new[] { "Wisdom" } });`,
    },
  },
}

export default Examples
